
<script>
    import PreviewComponent from "./PreviewComponent";
    import UserStatsComponent from "../../components/pagesbuilder/dynamic-components/UserStatsComponent";
    

    export default {
        name: "PreviewUserStatsComponent",
        mixins: [PreviewComponent,UserStatsComponent],                        
        methods:{            
            navigateToInbox(){
                window.location.href = '/inbox';
            }
            
        }
    }
</script>
